"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stoneStorageConfig = void 0;
exports.stoneStorageConfig = {
    name: 'storage-stone',
    fullname: 'Stone Storage',
    description: 'Storage for stones.',
    type: 'storage',
    width: 1,
    height: 1,
    levelMax: 9,
    canBeDisabled: false,
    requiredTechnology: 'stone',
    levels: [
        { level: 0, constructionCosts: {}, time: 1, provides: {}, costs: {}, stores: { stone: 10 } },
        { level: 1, constructionCosts: { iron: 5 }, time: 1, provides: {}, costs: {}, stores: { stone: 20 } },
        { level: 2, constructionCosts: { iron: 10 }, time: 1, provides: {}, costs: {}, stores: { stone: 40 } },
        { level: 3, constructionCosts: { iron: 30 }, time: 1, provides: {}, costs: {}, stores: { stone: 100 } },
        { level: 4, constructionCosts: { iron: 70 }, time: 1, provides: {}, costs: {}, stores: { stone: 200 } },
        { level: 5, constructionCosts: { iron: 150 }, time: 1, provides: {}, costs: {}, stores: { stone: 400 } },
        { level: 6, constructionCosts: { iron: 300 }, time: 1, provides: {}, costs: {}, stores: { stone: 1000 } },
        { level: 7, constructionCosts: { iron: 500 }, time: 1, provides: {}, costs: {}, stores: { stone: 2000 } },
        { level: 8, constructionCosts: { iron: 1000 }, time: 1, provides: {}, costs: {}, stores: { stone: 3000 } },
        { level: 9, constructionCosts: { iron: 2000 }, time: 1, provides: {}, costs: {}, stores: { stone: 5000 } },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/stonestorage.js
// module id = fEzJ
// module chunks = 0